<template>
  <div class="mobileBreadcrumbs" :class="{ 'mobileBreadcrumbs--small': small }">
    <div class="mobileBreadcrumbs__inner">
      <component :is="tag" class="mobileBreadcrumbs__link" :to="to" :href="href" @click="onClick">
        {{ title }}
      </component>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileBreadcrumbs',
  props: {
    to: {
      type: String,
      default: undefined,
    },
    href: {
      type: String,
      default: undefined,
    },
    title: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tag() {
      if (this.to) {
        return 'nuxt-link';
      } else if (this.href) {
        return 'a';
      } else {
        return 'button';
      }
    },
  },
  methods: {
    onClick(e) {
      this.$emit('click', e);
    },
  },
};
</script>

<style lang="scss">
.mobileBreadcrumbs {
  $root: &;
  position: relative;
  z-index: $zHeader - 1;
  display: flex;
  width: 100%;
  height: 62px;
  align-items: center;
  background-color: $cWhite;

  &__inner {
    padding: 2rem;
    width: calc(100% + 40px);
    background-color: $cWhite;
    margin-left: -20px;
    margin-right: -20px;
    box-shadow: 0 5px 15px rgba(23, 25, 51, 0.05);
  }

  &__link {
    color: $cMainLight;
    font-size: 1.4rem;
    line-height: 2rem;
    white-space: nowrap;
    text-overflow: ellipsis;

    &:before {
      @include icomoon('chevron-left-bold');
      padding-right: 1.5rem;
      font-size: 1.2rem;
    }
  }

  &--small {
    background-color: $cBg;
    height: 44px;

    #{$root}__inner {
      background-color: $cBg;
      padding: 1rem 2rem;
    }

    #{$root}__link {
      color: $cAddDark02;
    }
  }

  &--sticky {
    z-index: $zHeader - 1;
    #{$root}__inner {
      padding-left: 20px;
      padding-right: 20px;
    }
  }
}
</style>
